/** 对齐 iOS RewardTaskListChangeEvent：任务 execute / claim 成功后广播。 */
export const REWARD_TASK_LIST_CHANGE_EVENT = 'reward_task_list_changed'

export const TASK_TYPE = {
  DAILY: 'daily',
  NEW_USER: 'new_user'
}

export const TASK_STATUS = {
  UNFINISHED: 0,
  CLAIMABLE: 1,
  CLAIMED: 2
}

export const REWARD_ERROR_CODE = {
  TASK_NOT_FOUND: 4001,
  TASK_NOT_COMPLETED: 2001,
  TASK_REWARD_ALREADY_CLAIMED: 2002
}

export class RewardError extends Error {
  constructor (code, msg) {
    super(msg)
    this.name = 'RewardError'
    this.code = code
    this.msg = msg
  }
}

export function getRewardErrorI18nKey (code) {
  switch (code) {
    case REWARD_ERROR_CODE.TASK_NOT_COMPLETED:
      return 'reward.err_task_not_completed'
    case REWARD_ERROR_CODE.TASK_REWARD_ALREADY_CLAIMED:
      return 'reward.err_task_already_claimed'
    case REWARD_ERROR_CODE.TASK_NOT_FOUND:
      return 'reward.err_task_not_found'
    default:
      return 'reward.err_unknown'
  }
}

const REWARD_TASK_STATUS_SORT_ORDER = {
  [TASK_STATUS.CLAIMABLE]: 0,
  [TASK_STATUS.UNFINISHED]: 1,
  [TASK_STATUS.CLAIMED]: 2
}

/** 分组内排序：可领取 → 未完成 → 已领取；同 status 按 JSON 模板顺序（jsonIndex） */
export function sortRewardTasksByStatus (tasks) {
  return [...(Array.isArray(tasks) ? tasks : [])].sort((a, b) => {
    const orderA = REWARD_TASK_STATUS_SORT_ORDER[a?.status] ?? 99
    const orderB = REWARD_TASK_STATUS_SORT_ORDER[b?.status] ?? 99
    if (orderA !== orderB) return orderA - orderB

    const indexA = Number.isFinite(Number(a?.jsonIndex)) ? Number(a.jsonIndex) : 99
    const indexB = Number.isFinite(Number(b?.jsonIndex)) ? Number(b.jsonIndex) : 99
    if (indexA !== indexB) return indexA - indexB

    return String(a?.task_id ?? '').localeCompare(String(b?.task_id ?? ''))
  })
}
